import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import { ControlledCheckboxPropsType } from '@uikit/FormItems/constants';

export const ControlledSlideButton: FC<ControlledCheckboxPropsType> = ({
  name,
  control,
  rules,
  title,
  disabled,
  onChange,
  info,
  dataTestId,
}) => {
  return (
    <label className={`slide-button ${!disabled ? '' : 'disabled'}`}>
      {title && <span className="input-title">{title}</span>}
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => {
          return (
            <>
              <input
                data-test-id={`${dataTestId}-slide-button-input`}
                {...field}
                id={name}
                type="checkbox"
                disabled={disabled}
                checked={field.value}
                onChange={(e) => {
                  const checked = e.target.checked;
                  field.onChange(checked);
                  onChange && onChange(name, checked);
                }}
              />
              <span />
            </>
          );
        }}
      />
    </label>
  );
};
